// Tracks which sparks should show the "Are you done matching?" prompt on
// the Events page. One in-memory flag per spark:
//
//   - Set when the user views the Match page's grid layout. Profile-mode
//     exhausts the queue on its own, so we only ask after grid browsing
//     (where it's easy to skip past people without deciding).
//   - Cleared when the user taps "Not yet" on the prompt. Re-entering the
//     grid sets it again, which is the signal that they weren't done.
//
// Module-level state survives cross-route navigation (Events ↔ Match) but
// resets on a full page reload — we intentionally don't persist this, so
// a refresh gives the user a clean slate.

const sparksToPrompt = new Set<number>();

export function markShouldPromptDoneMatching(sparkId: number): void {
  sparksToPrompt.add(sparkId);
}

export function clearShouldPromptDoneMatching(sparkId: number): void {
  sparksToPrompt.delete(sparkId);
}

export function shouldPromptDoneMatching(sparkId: number): boolean {
  return sparksToPrompt.has(sparkId);
}
